import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom'; // Aggiunto Link per la navigazione corretta
import { LogIn } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { adminLogin } from '../../services/api';
import { toast } from 'sonner';

export const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await adminLogin(email, password);
      toast.success('Login effettuato con successo!');
      navigate('/admin/dashboard');
    } catch (error) {
      // GESTIONE MIGLIORATA DEGLI ERRORI
      
      // Caso 1: Errore 401 (Credenziali Sbagliate)
      if (error.response && error.response.status === 401) {
        // Usiamo console.warn (giallo) invece di error (rosso) per non sporcare la console
        console.warn('Login fallito: password errata');
        toast.error('Email o password non validi.');
      } 
      // Caso 2: Altri errori (es. Server Down 500, o Network Error)
      else {
        console.error('Errore critico login:', error);
        toast.error('Si è verificato un errore di connessione. Riprova più tardi.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-purple-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mb-4 flex justify-center">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-purple-600 rounded-full flex items-center justify-center">
              <LogIn className="w-8 h-8 text-white" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold">VeCo Shop Admin Login</CardTitle>
          <p className="text-gray-600 mt-2">Accedi per gestire le attività</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="info@vetrinaconsulenti.it"
                required
                className="w-full"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="w-full"
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-teal-600 hover:bg-teal-700"
              disabled={loading}
            >
              {loading ? 'Accesso in corso...' : 'Accedi'}
            </Button>
            <div className="text-right">
                <Link 
                    to="/admin/request-reset" 
                    className="text-sm text-teal-600 hover:text-teal-700 hover:underline"
                >
                    Password dimenticata?
                </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};